module.exports = __webpack_public_path__ + "img/icon-percentage-active.06a01d2a.svg";